<template>
	<footer class="m-footer">
		<div class="m-contact">
			<a class="m-phone-pill" href="tel:075586029999">
				<span class="m-phone-icon" aria-hidden="true">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.09 4.18 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.72c.12 1.05.36 2.07.72 3.03a2 2 0 0 1-.45 2.11L8.91 10.91a16 16 0 0 0 6 6l1.05-1.05a2 2 0 0 1 2.11-.45c.96.36 1.98.6 3.03.72A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
				<span class="m-phone-text">官方电话：0755-8602 9999</span>
			</a>
			<a class="m-phone-pill" href="tel:18823452333">
				<span class="m-phone-icon" aria-hidden="true">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.09 4.18 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.72c.12 1.05.36 2.07.72 3.03a2 2 0 0 1-.45 2.11L8.91 10.91a16 16 0 0 0 6 6l1.05-1.05a2 2 0 0 1 2.11-.45c.96.36 1.98.6 3.03.72A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
				<span class="m-phone-text">服务咨询：188-2345-2333</span>
			</a>
		</div>

		<nav class="m-links" aria-label="footer links">
			<a class="m-legal" href="#" @click.prevent="$emit('open-license')">营业执照</a>
			<span class="m-sep">|</span>
			<a class="m-legal" href="#" @click.prevent="$emit('open-permit')">增值电信业务经营许可证</a>
		</nav>

		<div class="m-company">深圳市化化科技有限公司</div>
		<div class="m-copyright">Copyright © HUAHUA 化化 保留所有权利</div>
		<div class="m-icp"><a href="#" class="m-icp-link" @click.prevent="$emit('open-miit')">粤ICP备2025456954号-2</a></div>
	</footer>
</template>

<script>
export default {
	name: 'MobileFooter'
}
</script>

<style scoped>
.m-footer{padding:calc(64 * var(--rpx)) 16px;background:#F4F7FB;text-align:center;font-size:calc(24 * var(--rpx));color:#262626}
.m-contact{display:flex;flex-direction:column;align-items:center;gap:calc(24 * var(--rpx));margin-bottom:calc(64 * var(--rpx))}
.m-phone-pill{display:inline-flex;align-items:center;justify-content:center;gap:calc(12 * var(--rpx));width:calc(640 * var(--rpx));max-width:100%;height:calc(86 * var(--rpx));border-radius:999px;border:calc(2 * var(--rpx)) solid #262626;text-decoration:none;color:#262626;font-size: calc(28 * var(--rpx));}
.m-phone-icon{display:inline-flex;align-items:center;justify-content:center;}
.m-phone-text{font-weight:600}
.m-links{display:flex;justify-content:center;gap:12px;align-items:center;margin-bottom:calc(32 * var(--rpx))}
.m-legal{text-decoration:underline;color:#262626;cursor:pointer}
.m-sep{}
.m-company{margin-bottom:calc(32 * var(--rpx));color:#262626}
.m-copyright{margin-bottom:calc(32 * var(--rpx));color:#262626}
.m-icp-link{text-decoration:underline;color:#262626;cursor:pointer}

@media (max-width:420px){
	.m-phone-pill{width:100%}
}
</style>
